import SETTING_ROUTES from '@/presentation/modules/setting/constants/routes/index.js';

const settingRoutes = [
	{
		name: SETTING_ROUTES.root.name,
		path: SETTING_ROUTES.root.path,
		redirect: SETTING_ROUTES.root.redirect,
		meta: SETTING_ROUTES.root.meta,
		component: SETTING_ROUTES.root.component,
		children: [
			{
				name: SETTING_ROUTES.setting.name,
				path: SETTING_ROUTES.setting.path,
				meta: SETTING_ROUTES.setting.meta,
				component: SETTING_ROUTES.setting.component,
			},
			{
				name: SETTING_ROUTES.accountDetail.name,
				path: SETTING_ROUTES.accountDetail.path,
				meta: SETTING_ROUTES.accountDetail.meta,
				component: SETTING_ROUTES.accountDetail.component,
			},
			{
				name: SETTING_ROUTES.wallet.name,
				path: SETTING_ROUTES.wallet.path,
				meta: SETTING_ROUTES.wallet.meta,
				component: SETTING_ROUTES.wallet.component,
			},
		],
	},
];

export default settingRoutes;
